/**
 * This functions is useful for locations which are shared to client connections. It allows you to know if a location belongs to the
 * client who is requesting to view a given location. Note that the authorization to view this location is not handled by this function, it
 * is handled by the backend.
 */
export const isLocationOwnedByViewingClient =
  (viewingClient: { id: string }) => (location: { client: { id: string } }) => {
    return viewingClient.id === location.client.id;
  };
